import PropTypes from "prop-types";

// Card for Programs

const CardProgram = ({ item }) => {
	const placeholderImage =
		"/wp-content/themes/masc/dist/images/svg/placeholder.svg";

	const disciplines =
		item.disciplines &&
		item.disciplines.map((discipline, i) => <div key={i}>{discipline}</div>);

	const types =
		item.types && item.types.map((type, i) => <div key={i}>{type}</div>);

	const languages = item.languages && item.languages.join(", ");

	let locale = window.location.href.indexOf("fr") > -1 ? "fr" : "en";

	return (
		<li
			className="card-program"
			aria-label={item.name}
			data-aos-duration="750"
			data-aos="fade"
			data-aos-delay="500"
		>
			<a href={item.url}>
				<div className="card-program__image">
					<img
						src={item.image ? item.image : placeholderImage}
						alt={item.image_alt}
					/>
				</div>
				<div className="card-program__info">
					<div className="info__wrap">
						<h3>{item.name}</h3>
						<h4 className="h5">
							{locale == "en" ? "by " : "par "} {item.artist}
						</h4>
						<p>{item.short_desc}</p>
					</div>
					<div className="tags">
						<div className="tags__wrap">
							<div className="disciplines">{disciplines}</div>
							<div className="types">{types}</div>
						</div>
						<div className="languages">{languages}</div>
					</div>
				</div>
			</a>
		</li>
	);
};

export default CardProgram;

CardProgram.propTypes = {
	item: PropTypes.instanceOf(Object).isRequired,
};
